export default __webpack_public_path__ + "static/media/protocol-3.54101241.png";